import React from "react";
import ReactDOM from "react-dom";

export default function Modal({ open, onClose, children }) {
  if (!open) return null;

  return ReactDOM.createPortal(
    <div >
      <div className="mu-dialog-wrapper table" >
        <div class="mu-dialog  mu-scale" >
          <div class="mu-dialog-body">
            <i data-v-c079c198="" onClick={onClose} class="close"></i>
            <div data-v-c079c198="" class="imgBox">
               {children}
            </div>
          </div>
        </div>
      </div>
      <div class="mu-overlay" onClick={onClose} ></div>
    </div>

    ,
    document.body // 👈 直接挂载到 body
  );
}